import { AbstractControl, UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms'
import * as lodash from 'lodash'

export function validateForm(formGroup: AbstractControl, refresh = true): boolean {
  if (formGroup instanceof UntypedFormControl) {
    formGroup.markAsTouched()
    if (refresh) {
      formGroup.updateValueAndValidity()
    }
    return lodash.isNil(formGroup.errors)
  }
  let controls = []
  if (formGroup instanceof UntypedFormGroup) {
    controls = lodash.values(formGroup.controls)
  }
  if (formGroup instanceof UntypedFormArray) {
    controls = formGroup.controls
  }

  return lodash.every(
    controls.map((ctrl) => validateForm(ctrl, refresh)),
    (valid) => valid
  )
}

export function SaveForm(refresh = false) {
  return function (target: any, propertyName: string, descriptor: TypedPropertyDescriptor<Function>) {
    const method = descriptor.value

    descriptor.value = function () {
      const form: AbstractControl = arguments[0]
      const isFormValid = validateForm(form, refresh)
      if (!isFormValid || form.invalid) {
        return null
      } else {
        return method.apply(this, arguments)
      }
    }
  }
}
